import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "react-bootstrap";
import { CSVLink } from "react-csv";
import "bootstrap/dist/css/bootstrap.min.css";
import { formattedDateTime } from "../utility/dateFormate";
import { base_url } from "../api/api-url";
import ReportTable from "../components/TableComponents/ReportTable";
import { Paper } from "@mui/material";
import { isAdminOrIsUser } from "../utility/isAdmin";
import { decryptText } from "../utility/cryptoUtils";
import { Dropdown } from 'react-bootstrap';

const ReportPage = () => {
  
  const [filters, setFilters] = useState({
      startDate: "",
      endDate: "",
      department: "",
      staff: "",
      priority: "",
  });
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(5);
  const [departments, setDepartments] = useState([]);
  const [staffMembers, setStaffMembers] = useState([]);

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {

    fetchTickets();
    fetchStaff();
    fetchDepartments();

    if(!isAdminOrIsUser()) return setFilters((data)=> ({ ...data, "department": decryptText(localStorage.getItem('department'))}));
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await fetch(`${base_url}/department`);
      const data = await res.json();
      console.log(data.data);

      setDepartments(data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchStaff = async () => {
    try {
      const res = await fetch(`${base_url}/user-getAll`);
      const data = await res.json();
      console.log(data);

      // if (data.success) {
      setStaffMembers(data.data.map((user) => user.fullName));
      // }
    } catch (error) {
      console.error("Error fetching staff members:", error);
    }
  };

  const fetchTickets = async (filterParams = {}) => {
    try {
      const res = await fetch(`${base_url}/analytics`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(filterParams),
      });

      const data = await res.json();
      const tickets = data?.data || [];
      console.log(tickets);
      

      const mappedData = tickets.map((item, index) => ({
        id: index + 1,
        ticketId: item.ticketId,
        title: item.issueTitle,
        escalatedBy: item.escalatedBy,
        description: item.description,
        depTicketId: item.depTicketId,
        status: item.status,
        department: item.assignedDepartment?.label || "N/A",
        staff: item.assignedTo?.[0]?.fullName || "N/A",
        priority: item.priority,
        date: new Date(item.createdAt).toISOString().split("T")[0],
        expectedResolutionDate: formattedDateTime(item.expectedResolutionDate),
        issueCategory: item.issueCategory || "N/A",
        conversation :item.conversation?.message ||"N/A",
        summary:item.summary?.message ||"N/A",
        closedBy:item.closedBy?.message ||"N/A",


      }));

      setFilteredData(mappedData);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  const handleFilterChange = async (e) => {
    const { name, value } = e.target;
    const updatedFilters = { ...filters, [name]: value };
    setFilters(updatedFilters);
console.log(updatedFilters);

    // On selecting both dates, fetch departments and staff
    if (name === "startDate" || name === "endDate") {
      const { startDate, endDate } = updatedFilters;
      if (startDate && endDate) {
        await fetchDepartments();
        await fetchStaff();
      }
    }
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const { startDate, endDate, department, staff, priority } = filters;

    const filterBody = {
      startDate: startDate || undefined,
      endDate: endDate || undefined,
      department: department || undefined,
      assignedTo: staff || undefined,
      priority: priority || undefined,
    };

    fetchTickets(filterBody);
  };

  const headers = [
    { label: "Sno", key: "id"},
    { label: "Ticket ID", key: "ticketId" },
    { label: "Issue Title", key: "title" },
    { label: "Escalated By", key: "escalatedBy" },
    { label: "Issue Description", key: "description" },
    { label: "Department Ticket ID", key: "depTicketId" },
    { label: "Status", key: "status" },
    { label: "Department", key: "department" },
    { label: "Assigned Staff", key: "staff" },
    { label: "Priority", key: "priority" },
    { label: "Escalation Date", key: "date" },
    { label: "Expected Resolution Date", key: "expectedResolutionDate" },
    { label: "Issue Category", key: "issueCategory" },
    { label: "Conversation", key: "conversation" },
    { label: "Resloution", key: "summary" },
    { label: "Closed By", key: "closedBy" },
  ];

  return (
    <Paper
   elevation={3}
   sx={{
     bgcolor: '#1e1e1e',
     p: 2,
     borderRadius: 2,
     color: '#fff',
     boxShadow: '0 2px 10px rgba(0,0,0,0.5)',
   }}
 >
      <h3 className="mb-4">Ticket Reports</h3>

     <Form className="mb-4" onSubmit={handleFilterSubmit}>
        <div className="row g-3">
          <Form.Group className="col-12 col-md-6 col-lg-3 mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="startDate"
              value={filters.startDate}
              required
              onChange={handleFilterChange}
              className="bg-secondary text-white border-0"
            />
          </Form.Group>
          <Form.Group className="col-12 col-md-6 col-lg-3 mb-3">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={handleFilterChange}
              required
              className="bg-secondary text-white border-0"
            />
          </Form.Group>

          {isAdminOrIsUser() && (
            <Form.Group className="col-12 col-md-6 col-lg-2 mb-3 position-relative">
              <Form.Label>Department</Form.Label>
              <Dropdown>
                <Dropdown.Toggle 
                  variant="secondary" 
                  id="department-dropdown"
                  className="w-100 bg-secondary text-white border-0 text-start pe-4"
                >
                  {filters.department || "All"}
                  <span className="position-absolute end-0 me-2">
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1.5L6 6.5L11 1.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu 
                  className="w-100 bg-secondary text-white"
                  style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                  }}
                >
                  <Dropdown.Item 
                    className="text-white bg-secondary"
                    onClick={() => handleFilterChange({ target: { name: 'department', value: '' } })}
                    active={!filters.department}
                  >
                    All
                  </Dropdown.Item>
                  {departments.map((dept, idx) => (
                    <Dropdown.Item 
                      key={idx}
                      className={`text-white ${filters.department === dept.label ? 'bg-dark' : 'bg-secondary'}`}
                      onClick={() => handleFilterChange({ target: { name: 'department', value: dept.label } })}
                      active={filters.department === dept.label}
                    >
                      {dept.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Form.Group>
          )}

          <Form.Group className="col-12 col-md-6 col-lg-2 mb-3 position-relative">
            <Form.Label>Assigned Staff</Form.Label>
            <Dropdown>
              <Dropdown.Toggle 
                variant="secondary" 
                id="staff-dropdown"
                className="w-100 bg-secondary text-white border-0 text-start pe-4"
              >
                {filters.staff || "All"}
                <span className="position-absolute end-0 me-2">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu 
                className="w-100 bg-secondary text-white"
                style={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                <Dropdown.Item 
                  className="text-white bg-secondary"
                  onClick={() => handleFilterChange({ target: { name: 'staff', value: '' } })}
                  active={!filters.staff}
                >
                  All
                </Dropdown.Item>
                {staffMembers.map((staff, idx) => (
                  <Dropdown.Item 
                    key={idx}
                    className={`text-white ${filters.staff === staff ? 'bg-dark' : 'bg-secondary'}`}
                    onClick={() => handleFilterChange({ target: { name: 'staff', value: staff } })}
                    active={filters.staff === staff}
                  >
                    {staff}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>

          <Form.Group className="col-12 col-md-6 col-lg-2 mb-3 position-relative">
            <Form.Label>Priority</Form.Label>
            <Dropdown>
              <Dropdown.Toggle 
                variant="secondary" 
                id="priority-dropdown"
                className="w-100 bg-secondary text-white border-0 text-start pe-4"
              >
                {filters.priority || "All"}
                <span className="position-absolute end-0 me-2">
                  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu 
                className="w-100 bg-secondary text-white"
                style={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
              >
                <Dropdown.Item 
                  className="text-white bg-secondary"
                  onClick={() => handleFilterChange({ target: { name: 'priority', value: '' } })}
                  active={!filters.priority}
                >
                  All
                </Dropdown.Item>
                {['High', 'Medium', 'Low', 'Critical'].map((priority, idx) => (
                  <Dropdown.Item 
                    key={idx}
                    className={`text-white ${filters.priority === priority ? 'bg-dark' : 'bg-secondary'}`}
                    onClick={() => handleFilterChange({ target: { name: 'priority', value: priority } })}
                    active={filters.priority === priority}
                  >
                    {priority}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </div>

        <style>
          {`
            .dropdown-menu::-webkit-scrollbar {
              display: none;
            }
            .dropdown-toggle::after {
              display: none;
            }
            .dropdown-item:hover, .dropdown-item:focus {
              background-color: #495057 !important;
              color: white !important;
            }
            .dropdown-toggle {
              position: relative;
            }
          `}
        </style>

        <div className="d-flex flex-column flex-md-row justify-content-end align-items-center gap-3">
          <Button variant="primary" type="submit" className="w-40 w-md-auto">
            Apply Filters
          </Button>
          <CSVLink
            data={filteredData}
            headers={headers}
            filename="ticket-report.csv"
            className="btn btn-success w-40 w-md-auto"
          >
            Export CSV
          </CSVLink>
        </div>
      </Form>
<ReportTable  filteredData={filteredData}
  page={page}
  rowsPerPage={rowsPerPage}
  setPage={setPage}
  setRowsPerPage={setRowsPerPage}/>
   
    </Paper>
  );
};  

export default ReportPage;
